import { render } from "./indexContractComponent.vue?vue&type=template&id=e0030386"
import script from "./indexContractComponent.vue?vue&type=script&lang=js"
export * from "./indexContractComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__